<div class="top-section">
    <h3>
        Shipping Lines
    </h3>
</div>

<section class="rate-request rate-request-sec">
    <div class="middle-section">
        <div class="container">
            <div class="rate-request-form">
                <div class="rate-request-form-inner">
                    <div class="request-btn">
                        <input type="text" class="form-control" pInputText size="50" placeholder="Search"
                            (change)="filterSearch($event.target.value)">
                        <div class="btn-search"><button class="btn  btn-go my-2 my-sm-0" type="submit"><img
                                    src="../../../assets/images/Group 103.svg"></button></div>
                    </div>
                </div>

                <div class="rate-request-form-innera text-end mb-3">
                    <!-- <a class="btn btn-signIn" (click)="ShippingLineId=0;"  href="javascript:void(0)"
                        data-bs-toggle="modal" data-bs-target=".view-offredrate" >
                        <i class="fa fa-plus"></i> Add Shipping Line</a> -->
                    <button class="btn btn-signIn" (click)="openShippingLineModal(0)"> 
                        <i class="fa fa-plus"></i> Add Shipping Line
                    </button>

                </div>

                <div class="table-responsive rate-request-tbl">
                    <p-table [value]="shippingData">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Company Name</th>
                                <th>Company Code</th>
                                <th>Actions</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-shipping>
                            <tr>
                                <td>{{ shipping.companyName }}</td>
                                <td>{{ shipping.companyCode }}</td>
                                <td>
                                    <!-- <a class="action-btn " tooltipPosition="top" pTooltip="Edit Shipping Line"
                                        data-toggle="modal" data-target=".view-offredrate"
                                        (click)="getShippingdetails(shipping.id)">
                                        <i class="fa fa-edit"></i> </a> -->
                                    <a class="action-btn" tooltipPosition="top" pTooltip="Edit Shipping Line"
                                    (click)="openShippingLineModal(shipping.id)">
                                    <i class="fa fa-edit"></i></a>
                                </td>
                            </tr>
                        </ng-template>

                    </p-table>
                </div>

                <p-paginator *ngIf="totalcount > 0" [rows]="requestVM.pageSize" [rowsPerPageOptions]="[5,10,20]"
                    [totalRecords]="totalcount" (onPageChange)="paginate($event)"></p-paginator>

                <div *ngIf="totalcount == 0">
                    <span>No records found</span>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #shippingLineModal let-modal>
    <div class="modal-header">
        <h3 *ngIf="ShippingLineId === 0">Add ShippingLine</h3>
        <h3 *ngIf="ShippingLineId > 0">Edit ShippingLine</h3>
        <button type="button" class="close-btn" (click)="modal.dismiss()" aria-label="Close">
            <span class="pi pi-fw pi-times"></span>
        </button>
    </div>
    <form [formGroup]="ShippingForm">
        <div class="modal-body">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-md-4 form-group pRel">
                        <label class="custom-labal "> Company Name </label>
                        <input type="text" class="form-control" formControlName="companyName" [ngClass]="{ 'is-invalid':(submitted && f.companyName.errors) || ( f.companyName.errors && f.companyName.touched) || (f.companyName.errors && f.companyName.dirty)}" />
                        <div *ngIf="(submitted && f.companyName.errors) || ( f.companyName.errors && f.companyName.touched) || (f.companyName.errors && f.companyName.dirty)" class="invalid-feedback">
                            <div class="port-error " *ngIf="f.companyName.errors.required"> Company Name is required
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 form-group pRel">
                        <label class="custom-labal "> Company Code </label>
                        <input type="text" class="form-control" formControlName="companyCode" [ngClass]="{ 'is-invalid':(submitted && f.companyCode.errors) || ( f.companyCode.errors && f.companyCode.touched) || (f.companyCode.errors && f.companyCode.dirty)}" />
                        <div *ngIf="(submitted && f.companyCode.errors) || ( f.companyCode.errors && f.companyCode.touched) || (f.companyCode.errors && f.companyCode.dirty)" class="invalid-feedback">
                            <div class="port-error " *ngIf="f.companyCode.errors.required"> Company Code is required
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 form-group pRel">
                        <p-checkbox [(ngModel)]="isReceiveFrieghtRequestOnly" binary="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                        <span class="checkbox-custom-labal">Only receive rate request</span>
                    </div>
                    <div class="col-md-4 form-group pRel">
                        <p-checkbox [(ngModel)]="isPremiumListing" binary="true" [ngModelOptions]="{standalone: true}"></p-checkbox>
                        <span class="checkbox-custom-labal">Premium Listings</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 form-group">
                        <label class="custom-labal ">
                            Valid Until
                        </label>
                        <div class="pRel">
                            <p-calendar formControlName="receiveFrieghtRequestExpiryDate" [readonlyInput]="true" showIcon="true" showButtonBar="true" placeholder="Date" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}" icon="pi pi-calendar" iconPos="left"
                            dateFormat="dd-MM-yy"></p-calendar>
                        </div>
                    </div>
                    <div class="col-md-4 form-group">
                        <label class="custom-labal ">
                            Valid Until
                        </label>
                        <div class="pRel">
                            <p-calendar formControlName="premiumListingExpiryDate" [readonlyInput]="true" showIcon="true" showButtonBar="true" placeholder="Date" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}" icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy"></p-calendar>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 form-group">
                        <label class="custom-labal ">
                            Add Representatives
                        </label>
                        <div class="shipping-sec">
                            <div class="shipping-lines">
                                <div class="select-section-relative">
                                    <p-multiSelect formControlName="shippingRepresentative" [options]="masterRepresentatives" optionLabel="userName" defaultLabel="Representatives" [filter]="true" [maxSelectedLabels]="1" (onChange)="onRepresentativeChange($event)">
                                    </p-multiSelect>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 form-group">
                        <textarea disabled formControlName="txtAreashippingRepresentative" rows="5" cols="40" pInputTextarea [(ngModel)]="respresentatives"></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" (click)="save()" class="btn btn-signIn" *ngIf="ShippingLineId == 0">Save</button>
            <button type="button" (click)="update()" class="btn btn-signIn" *ngIf="ShippingLineId > 0">Update</button>
        </div>
    </form>
</ng-template>
